import React from 'react';
import MemberDetailsCard from './MemberDetailsCard';

const PERSONAL_COLUMNS = [
  { field: 'Name', header: 'Name' },
  { field: 'ID_Num', header: 'ID number' },
  { field: 'Date_of_Birth', header: 'Date Of Birth' },
  { field: 'Age', header: 'Age' },
  { field: 'Telephone', header: 'Phone' },
];

const POLICY_COLUMNS = [
  { field: 'Incep_Date', header: 'Date Joined' },
  { field: 'waitingPeriod', header: 'Waiting Period' },
  { field: 'PolicyMaturityDate', header: 'Maturity Date' },
];

const ViewSpouseMemberTable = ({ activeUserData }) => (
  <MemberDetailsCard
    title="SPOUSE MEMBER DETAILS"
    sections={[
      { value: [activeUserData.memberSpouse], columns: PERSONAL_COLUMNS, emptyMessage: 'No Users found' },
      { value: [activeUserData.memberSpouse], columns: POLICY_COLUMNS, emptyMessage: 'No Users found' },
    ]}
  />
);

export default ViewSpouseMemberTable;
